/**
 * LogoTile — wraps the (white-on-transparent) ImpressSite Pro mark in a
 * dark tile so it stays legible on the app's light glassmorphism surfaces.
 *
 *   size:    px (default 32) — sets width AND height
 *   radius:  px (default computed: 8 for small, 16 for >=64)
 *   padding: px (default computed: 4 for small, 12 for >=64)
 *   className: extra classes on the outer tile
 */
export default function LogoTile({
    size = 32,
    radius,
    padding,
    className = "",
    testId,
}) {
    const r = radius ?? (size >= 64 ? 16 : 8);
    const p = padding ?? (size >= 64 ? 12 : 4);
    return (
        <span
            aria-hidden
            className={`inline-flex items-center justify-center shrink-0 ${className}`}
            data-testid={testId}
            style={{
                width: size,
                height: size,
                background: "#0F172A",
                borderRadius: r,
                padding: p,
                lineHeight: 0,
            }}
        >
            <img
                src="/logo.png"
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
        </span>
    );
}
